import React, { useState } from "react";
import {
  Box,
  Input,
  Text,
  Button,
  Flex,
  useToast,
  Image,
  Container,
  VStack,
  FormLabel,
  FormControl,
  Textarea,
} from "@chakra-ui/react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import axios from "axios";
import * as mod from "../../url";
import { formats, modules } from "../../utils/quillModules";
import Navbar from "../Navbar/Navbar";
import Sidebar from "../Sidebar";
const storedData = JSON.parse(sessionStorage.getItem("superAdminLawvs"));
const token = storedData?.data?.token;
const config = { headers: { Authorization: `${token}` } };
const userId = storedData?.data.superAdmin._id;
const userType = storedData?.data.superAdmin.role;

const SIDEBAR_WIDTH = "250px";

const CreateVideo = () => {
  const [title, setTitle] = useState("");
  const [videoUrl, setVideoUrl] = useState("");
  const [content, setContent] = useState("");
  const [imageUrl, setImageUrl] = useState("");
  const [imageFile, setImageFile] = useState(null);
  const [metTitle, setMetaTitle] = useState("");
  const [metaKeyword, setMetaKeyword] = useState("");
  const [metaDes, setMetaDes] = useState("");
  const [author, setAuthor] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const toast = useToast();
  const CLOUDINARY_UPLOAD_PRESET = "unsigned_preset"; // your created preset
  const CLOUDINARY_CLOUD_NAME = "dwikskvzt"; // Your Cloudinary cloud name
  //   const uploadImageToCloudinary = async (file) => {
  //     const formData = new FormData();
  //     formData.append("file", file);
  //     // formData.append("cloud_name", "dwikskvzt"); // 🔁 Replace with your Cloudinary cloud name
  //     // formData.append("upload_preset", CLOUDINARY_UPLOAD_PRESET);
  //     formData.append("upload_preset", CLOUDINARY_UPLOAD_PRESET);
  //     formData.append("folder", "lawvs/video");

  //     const res = await axios.post(
  //       `https://api.cloudinary.com/v1_1/${CLOUDINARY_CLOUD_NAME}/image/upload`,
  //       formData
  //     );
  //     return res.data.secure_url;
  //   };

  const handleSubmit = async () => {
    setIsSubmitting(true);
    try {
      let uploadedImageUrl = "";

      //   if (imageFile) {
      //     uploadedImageUrl = await uploadImageToCloudinary(imageFile);
      //     setImageUrl(uploadedImageUrl);
      //   }

      await axios.post(
        `${mod.api_url}/api/v1/video/create-video`,
        {
          title,
          subtitle: content,
          //   NewsImage: uploadedImageUrl,
          videoUrl,
          metaKeyword: metaKeyword,
          metaDescription: metaDes,
          authorName: author,
          userId: userId,
          userType: userType,
        },
        config
      );

      toast({
        title: "video submitted.",
        description: "Your video was successfully posted.",
        status: "success",
        duration: 3000,
        isClosable: true,
      });

      // Reset form
      setTitle("");
      setContent("");
      setImageFile(null);
      setImageUrl("");
      setMetaTitle("");
      setMetaKeyword("");
      setMetaDes("");
      setAuthor("");
    } catch (error) {
      console.error(
        "Error submitting video:",
        error.response?.data || error.message
      );
      toast({
        title: "Submission failed.",
        description: "Something went wrong while posting the video.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setIsSubmitting(false); // Enable button again if needed
    }
  };

  return (
    <>
      <Navbar />
      <Sidebar />
      <Box mt="70px" ml={{ base: 0, md: SIDEBAR_WIDTH }} p={0}>
        <Container maxW="" bg="white" p={5} borderRadius="md" boxShadow="md">
          <Text
            fontSize={{ base: "xl", md: "2xl" }}
            fontWeight="bold"
            mb={6}
            bg="#D29B3F"
            p={3}
            borderRadius="md"
            textAlign="center"
          >
            Add Videos
          </Text>

          <VStack spacing={5} align="stretch">
            <FormControl isRequired>
              <FormLabel>Videos Title</FormLabel>
              <Input
                placeholder="Enter Title"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
              />
            </FormControl>
            <FormControl isRequired>
              <FormLabel>Videos Link</FormLabel> refer to
              https://www.youtube.com/embed/change-endpont
              <Input
                placeholder="youtube video link: https://www.youtube.com/embed/OtgoOIxkbm8"
                value={videoUrl}
                onChange={(e) => setVideoUrl(e.target.value)}
              />
            </FormControl>

            {/* <FormControl>
              <FormLabel>Videos Upload Image</FormLabel>
              <Inpx`ut
                type="file"
                accept="image/*"
                onChange={(e) => setImageFile(e.target.files[0])}
              />
            </FormControl> */}

            {/* {imageFile && (
              <Image
                src={URL.createObjectURL(imageFile)}
                alt="Preview"
                maxH="200px"
                objectFit="cover"
                borderRadius="md"
              />
            )} */}

            <Box marginBottom="30px">
              <FormLabel>Videos Description</FormLabel>
              <ReactQuill
                value={content}
                onChange={setContent}
                modules={modules}
                formats={formats}
                theme="snow"
                placeholder="Write your video here..."
                style={{ height: "300px", marginBottom: "20px" }}
              />
            </Box>

            {/* <FormControl>
              <FormLabel>Videos Meta Description</FormLabel>
              <Input
                placeholder="Meta Description"
                value={metaDes}
                onChange={(e) => setMetaDes(e.target.value)}
              />
            </FormControl>

            <FormControl>
              <FormLabel>Videos Meta Keywords</FormLabel>
              <Input
                placeholder="Meta Keywords"
                value={metaKeyword}
                onChange={(e) => setMetaKeyword(e.target.value)}
              />
            </FormControl> */}

            <Flex justify="flex-end" gap={4} pt={4}>
              <Button
                variant="outline"
                onClick={() => {
                  setTitle("");

                  setAuthor("");
                  setContent("");
                  setImageFile(null);
                  setImageUrl("");
                  setMetaTitle("");
                  setMetaDes("");
                  setMetaKeyword("");
                }}
              >
                Cancel
              </Button>
              <Button
                colorScheme={isSubmitting ? "gray" : "green"}
                isDisabled={isSubmitting}
                onClick={handleSubmit}
              >
                {isSubmitting ? "Submitting..." : "Submit"}
              </Button>
            </Flex>
          </VStack>
        </Container>
      </Box>
    </>
  );
};

export default CreateVideo;
